<template>
  <div :class="$style.field">
    <label :for="id">
      {{ entity.label }}
      <i v-if="required">*</i>
    </label>
    <multiselect
      :id="id"
      v-model="value"
      label="label"
      track-by="value"
      :disabled="readonly"
      :placeholder="entity.description"
      :allow-empty="!required"
      :show-labels="!required"
      :options="entity.field.options"
      :searchable="true"
      select-label=""
      selected-label="✕"
      deselect-label="✕"
    >
      <template #noResult>
        <span>No matches found</span>
      </template>
    </multiselect>
    <p v-show="error && showError">{{ error }}</p>
  </div>
</template>

<script>
import Field from "./field";
import Multiselect from "vue-components/vue-multiselect";

export default {
  mixins: [Field],
  components: { Multiselect },
  methods: {
    typecast(option) {
      return option ? option.value : null;
    },
  },
};
</script>

<style module lang="less" src="./field.less"></style>



// WEBPACK FOOTER //
// picklist-field.vue?4be2398c